export default __webpack_public_path__ + "static/home-recipes-bg-a709c462640b183e2fd408d49b96d3e2.png";